module.exports = __webpack_public_path__ + "static/logo-c87fbb51190176830bd042b778bd0b08.png";